import { make } from 'vuex-pathify'

const state = () => ({
  drawer: false,
  showNotLoggedInModal: false,
  errorMessage: null,
  showErrorModal: false
})

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations
}
